import {Address} from "../../address/model/Address";
import {Branch} from "../../branches/model/Branch";
import {S3File} from "../../image_cropper/service/image.service";

export class Brand {

    id: number;

    brandName: string;

    name: string;

    title: string;

    mainHeaderColor: string;

    brandColorHex: string;

    sideHeaderColor: string;

    nmlsNumber: string;

    email: string;

    sendGridSenderId: number;

    address: Address;

    logo: S3File;
}

export class BrandConfigurations {
    employeeBranches: Branch;
}